ScoreTrekBattle.Statistics = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            active: false,
            playerId: null,
            player: null,
            $view: null
        };
    }
    resetStatus();

    function onViewRender(playerId) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.View.updateMenu(`/statistics`);
            ScoreTrekBattle.Template.render(`statistics/start`).then(view => {
                STATUS.active = true;
                STATUS.$view = view.$view;
                STATUS.playerId = playerId || ScoreTrekBattle.Session.getPlayerId();
                loadStatistics();
                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad(playerId) {
        return new Promise(function(resolve) {
            STATUS.active = true;
            STATUS.playerId = playerId || ScoreTrekBattle.Session.getPlayerId();
            resolve();
        });
    }

    function onViewUpdate(playerId) {
        return new Promise(function(resolve) {
            STATUS.playerId = playerId || ScoreTrekBattle.Session.getPlayerId();
            loadStatistics();
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function loadStatistics() {
        let $content, $error, $share;

        $content = STATUS.$view.find('[data-id="statisticsContent"]');
        $error = STATUS.$view.find('[data-id="statisticsError"]');
        $share = STATUS.$view.find('[data-id="share"]');

        STATUS.$view.find('[data-id="statisticsError"]').css('display', 'none');
        STATUS.$view.find('[data-id="statisticsContent"]').css('display', 'none');
        $share.css('display', 'none');

        if (!ScoreTrekBattle.Session.getPlayer()) {
            STATUS.$view.find('[data-id="statisticsEmpty"]').css('display', '');
            ScoreTrekBattle.Event.trigger('action.loginRequired');
            return;
        }

        ScoreTrekBattle.View.loading('statistics.load', true);

        Api.request(`/battle/statistics/${STATUS.playerId}`).then(result => {
            if (!STATUS.active || !STATUS.$view) {
                return;
            }
            renderStatistics(result);

            $content.css('display', ''); 
        }).catch(error => {
            console.error(error);

            if (!STATUS.active || !STATUS.$view) {
                return;
            }

            $error.css('display', '');
        }).finally(() => {
            ScoreTrekBattle.View.loading('statistics.load', false);

            if (!STATUS.active || !STATUS.$view) {
                return;
            }
        });
    }

    function renderStatistics(data) {
        let $empty, $data, $share;
        $empty = STATUS.$view.find('[data-id="statisticsEmpty"]');
        $data = STATUS.$view.find('[data-id="statisticsData"]');
        $share = STATUS.$view.find('[data-id="share"]');

        STATUS.player = data.player || null;

        renderPlayerBox(STATUS.player);

        if (!data || !data.hasData) {
            $empty.css('display', '');
            $share.css('display', 'none');
            return;
        }

        $data.css('display', '');
        $share.css('display', '').attr('data-trigger-action', `share:statistics:${STATUS.playerId}`);

        renderKPIs(data.kpi || {});
        renderRatingSummary(data.ratingSummary || null);
        renderPositions(data.positions || {});
        renderGameTypeMix(data.gameTypeMix || []);
        renderTopOpponents(data.topOpponents || []);
        loadRatingList(data.player ? data.player.id : '');
        loadTournamentsList(data.player ? data.player.id : '');
    }

    function renderPlayerBox(player) {
        let $box = STATUS.$view.find('[data-id="statisticsPlayer"]');

        $box.empty();

        if (!player) {
            $box.css('display', 'none');
            return;
        }

        let avatar = player.avatar || player.thumbnail || '';
        let club = player.club || null;

        let clubHtml = '';
        if (club) {
            let clubLogo = club.thumbnail || club.logo || ScoreTrekBattle.ASSETS.PLACEHOLDER.club;
            let clubAddress = `${club.zip || ''} ${club.city || ''}`.trim();
            clubHtml = [
                `<div class="player-club">`,
                    `<span class="player-club-logo" style="background-image:url('${clubLogo}');"></span>`,
                    `<span class="player-club-text">`,
                        `<span class="player-club-name">${__escapeHTML(club.official_name || '')}</span>`,
                        clubAddress ? `<span class="player-club-address">${__escapeHTML(clubAddress)}</span>` : '',
                    `</span>`,
                `</div>`
            ].join('');
        }

        let nicknameHtml = player.nickname
            ? `<span class="statistics-player-nickname">${__escapeHTML(player.nickname)}</span>`
            : '';

        $box.toggleClass('isProPlayer', !!player.pro_account).css('display', '').append(
            $([
                `<span class="player-avatar" style="background-image:url('${avatar}');"></span>`,
                `<span class="statistics-player-info">`,
                    nicknameHtml,
                    `<span class="statistics-player-name">${__escapeHTML(player.name || '')}</span>`,
                    clubHtml,
                `</span>`
            ].join(''))
        );
    }

    function renderKPIs(kpi) {
        let $view = STATUS.$view;
        $view.find('[data-id="kpiTournaments"]').text(kpi.tournaments || 0);
        $view.find('[data-id="kpiMatches"]').text(kpi.matches || 0);
        $view.find('[data-id="kpiQuote"]').text(kpi.quote || '0,0%');
        $view.find('[data-id="kpiRating"]').text(kpi.rating || 1000);
    }

    function renderRatingSummary(summary) {
        let $view = STATUS.$view;
        let $empty = $view.find('[data-id="ratingHistoryEmpty"]');
        let $content = $view.find('[data-id="ratingHistoryContent"]');

        if (!summary || !summary.rated) {
            $content.css('display', 'none');
            $empty.css('display', '');
            return;
        }

        $view.find('[data-id="ratingHistoryCurrent"]').text(summary.current);
        $view.find('[data-id="ratingHistoryDelta"]').empty().append(renderDelta(summary.delta));

        $view.find('[data-id="ratingHistoryHighest"]').text(summary.highest);
        $view.find('[data-id="ratingHistoryHighestDate"]').text(summary.highestDate || '');

        $view.find('[data-id="ratingHistoryLowest"]').text(summary.lowest);
        $view.find('[data-id="ratingHistoryLowestDate"]').text(summary.lowestDate || '');

        $view.find('[data-id="ratingHistoryStart"]').text(summary.start);
        $view.find('[data-id="ratingHistoryStartDate"]').text(summary.startDate || '');

        $view.find('[data-id="ratingHistoryFooter"]').text(
            __i18n('statistics/ratingHistory/footer', {
                count: summary.rated,
                startDate: summary.startDate || '',
                endDate: summary.currentDate || ''
            })
        );

        $content.css('display', '');
    }

    function renderDelta(delta) {
        let isPositive = delta > 0;
        let isNegative = delta < 0;
        let iconClass = isPositive
            ? 'fa-arrow-up'
            : (isNegative ? 'fa-arrow-down' : 'fa-minus');
        let state = isPositive ? 'positive' : (isNegative ? 'negative' : 'neutral');
        let sign = isPositive ? '+' : (isNegative ? '−' : '±');
        let value = Math.abs(delta);

        return $(`<span class="statistics-ratingHistory-delta" data-state="${state}"><i class="fa-solid ${iconClass}"></i> ${sign}${value}</span>`);
    }

    function renderPositions(positions) {
        let $view = STATUS.$view;
        let $bars = $view.find('[data-id="positionsBars"]');
        let $empty = $view.find('[data-id="positionsEmpty"]');
        let items = positions.items || [];
        let total = positions.total || 0;

        $bars.empty();

        if (total <= 0) {
            $empty.css('display', '');
            return;
        }

        let maxCount = items.reduce((max, item) => Math.max(max, item.count || 0), 0);

        items.forEach(item => {
            if (!item.count) {
                return;
            }
            let percent = (maxCount > 0) ? Math.max(2, Math.round(100 * item.count / maxCount)) : 0;
            $bars.append(
                $([
                    `<div class="statistics-bar-row">`,
                        `<span class="statistics-bar-label">${__i18n(`statistics/positions/${item.key}`)}</span>`,
                        `<span class="statistics-bar-track">`,
                            `<span class="statistics-bar-fill statistics-bar-fill--${item.key}" style="width: ${percent}%;"></span>`,
                        `</span>`,
                        `<span class="statistics-bar-value">${item.count}</span>`,
                    `</div>`
                ].join(''))
            );
        });
    }

    function renderGameTypeMix(mix) {
        let $view = STATUS.$view;
        let $bars = $view.find('[data-id="gameTypeMixBars"]');
        let $empty = $view.find('[data-id="gameTypeMixEmpty"]');

        $bars.empty();

        if (!mix || mix.length === 0) {
            $empty.css('display', '');
            return;
        }

        let maxTotal = mix.reduce((max, item) => Math.max(max, item.total || 0), 0);

        mix.forEach(item => {
            let percent = (maxTotal > 0) ? Math.max(2, Math.round(100 * item.total / maxTotal)) : 0;
            let colorHex = item.highlightColor || item.color || '#888888';
            $bars.append(
                $([
                    `<div class="statistics-bar-row">`,
                        `<span class="statistics-bar-label row-center">`,
                            `<span class="statistics-gameType-icon" style="background-image:url('/res/img/game/${item.gameType}.svg');"></span>`,
                            `<span>${__i18n(`gameType/${item.gameType}`)}</span>`,
                        `</span>`,
                        `<span class="statistics-bar-track">`,
                            `<span class="statistics-bar-fill" style="width: ${percent}%; background-color: ${colorHex};"></span>`,
                        `</span>`,
                        `<span class="statistics-bar-value">`,
                            `<span class="text-bold">${item.total}</span>`,
                            `<span class="color-white-50 text-small ml-tiny">${item.quote}</span>`,
                        `</span>`,
                    `</div>`
                ].join(''))
            );
        });

        __$i18n($bars);
    }

    function renderTopOpponents(opponents) {
        let $view = STATUS.$view;
        let $list = $view.find('[data-id="topOpponents"]');
        let $empty = $view.find('[data-id="topOpponentsEmpty"]');

        $list.empty();

        if (!opponents || opponents.length === 0) {
            $empty.css('display', '');
            return;
        }

        opponents.forEach(opp => {
            let avatar = opp.thumbnail || opp.avatar || '';
            let name = String(opp.name || '');
            let proClass = opp.pro_account ? ' isProPlayer' : '';

            $list.append(
                $([
                    `<div class="statistics-opponents-item${proClass}">`,
                        `<span class="statistics-opponents-item-avatar" style="background-image:url('${avatar}');"></span>`,
                        `<span class="statistics-opponents-item-name"></span>`,
                        `<span class="statistics-opponents-item-matches">`,
                            `<span class="text-bold">${opp.matches}</span>`,
                            `<span class="color-white-50 text-small ml-tiny">${__i18n('statistics/topOpponents/matchesSuffix')}</span>`,
                        `</span>`,
                    `</div>`
                ].join('')).find('.statistics-opponents-item-name').text(name).end()
            );
        });
    }

    function loadRatingList(playerId) {
        let $view = STATUS.$view;
        let $list = $view.find('[data-id="ratingList"]');

        if (!playerId) {
            $list.removeClass('loading').empty().append(renderNone('player/rating/none'));
            return;
        }

        Api.request('/battle/participant/rating', {
            playerId: playerId
        }).then(response => {
            if (!STATUS.active || !STATUS.$view) {
                return;
            }
            $list.empty();
            if (response.rating && response.rating.length > 0) {
                renderRatingItems(response.rating, $list);
            } else {
                $list.append(renderNone('player/rating/none'));
            }
        }).catch(error => {
            console.error(error);
            if (!STATUS.active || !STATUS.$view) {
                return;
            }
            $list.empty().append(`<div class="text-red pt-small">${__i18n(`error/${error.message || 'somethingWentWrong'}`)}</div>`);
        }).finally(() => {
            if (!STATUS.active || !STATUS.$view) {
                return;
            }
            $list.removeClass('loading');
        });
    }

    function renderRatingItems(rating, $list) {
        let promises = rating.map(ratingItem =>
            ScoreTrekBattle.Template.render('tournament/details/playerRating', {rating: ratingItem})
        );

        Promise.all(promises).then(views => {
            views.forEach(view => {
                $list.append(view.$view);
            });
        }).catch(error => {
            console.error(error);
            $list.append(`<span class="text-red">${__i18n('error/somethingWentWrong')}</span>`);
        });
    }

    function loadTournamentsList(playerId) {
        let $view = STATUS.$view;
        let $list = $view.find('[data-id="tournamentsList"]');

        if (!playerId) {
            $list.removeClass('loading').empty().append(renderNone('player/tournaments/none'));
            return;
        }

        Api.request('/battle/participant/tournaments', {
            playerId: playerId
        }).then(response => {
            if (!STATUS.active || !STATUS.$view) {
                return;
            }
            $list.empty();
            if (response.tournaments && response.tournaments.length > 0) {
                renderTournamentItems(response.tournaments, $list);
            } else {
                $list.append(renderNone('player/tournaments/none'));
            }
        }).catch(error => {
            console.error(error);
            if (!STATUS.active || !STATUS.$view) {
                return;
            }
            $list.empty().append(`<div class="text-red pt-small">${__i18n(`error/${error.message || 'somethingWentWrong'}`)}</div>`);
        }).finally(() => {
            if (!STATUS.active || !STATUS.$view) {
                return;
            }
            $list.removeClass('loading');
        });
    }

    function renderTournamentItems(tournaments, $list) {
        let promises = tournaments.map(entry => renderTournamentItem(entry));

        Promise.all(promises).then($items => {
            $items.forEach($item => {
                $list.append($item);
            });
        }).catch(error => {
            console.error(error);
            $list.append(`<span class="text-red">${__i18n('error/somethingWentWrong')}</span>`);
        });
    }

    function renderTournamentItem(entry) {
        return new Promise(resolve => {
            let tournament = entry.tournament || {};
            let position = entry.position || 0;
            let score = entry.score || 0;
            let positionHtml = renderPositionHtml(position);
            let scoreHtml = renderScoreHtml(score);

            ScoreTrekBattle.Tournament.renderTournamentItem(tournament, '', 0, true).then($tournament => {
                if (!tournament.id) {
                    $tournament.find('[data-id="tournamentItem"]').toggleClass('isRestricted', true).attr('href', 'javascript:');
                }
                $tournament.find('[data-id="tournamentItem"]').attr('data-event-is-public', tournament.isPublic ? 'yes' : 'no');
                resolve(
                    $('<div>').addClass('player-tournaments-item').append(
                        $('<span>').addClass('player-tournaments-item-position row-center row-end mt-small text-no-wrap').append(positionHtml),
                        $('<span>').addClass('player-tournaments-item-score row-center row-end mt-small text-no-wrap').append(scoreHtml),
                        $tournament.addClass('player-tournaments-item-tournament')
                    )
                );
            });
        });
    }

    function renderPositionHtml(position) {
        if (!position) {
            return `<span class="color-white-50 text-small"><i class="fa-solid fa-empty-set"></i></span>`;
        }
        let medal = '';
        if (position === 1) {
            medal = '<span class="color-gold mr-tiny"><i class="fa-solid fa-medal"></i></span>';
        } else if (position === 2) {
            medal = '<span class="color-silver mr-tiny"><i class="fa-solid fa-medal"></i></span>';
        } else if (position === 3) {
            medal = '<span class="color-bronze mr-tiny"><i class="fa-solid fa-medal"></i></span>';
        }
        return `${medal}<span class="text-bold">${position}.</span>`;
    }

    function renderScoreHtml(score) {
        if (!score) {
            return '';
        }
        return `<span class="color-white-50 mr-tiny"><i class="fa-solid fa-chart-pie-simple"></i></span><span class="color-green">${score}</span>`;
    }

    function renderNone(i18nKey) {
        return `<div class="text-white-50 pt-small"><i class="fa-solid fa-inbox"></i> ${__i18n(i18nKey)}</div>`;
    }

    _this = {
        getCurrentName: function(playerId) {
            var hasTournament;

            hasPlayer = STATUS.player && (STATUS.player.id === playerId);

            return hasPlayer ? STATUS.player.name : __i18n('statistics/player');
        },

        getShareHash: function(playerId) {
            return `/statistics/${playerId}`;
        }
    };

    addEventListener("DOMContentLoaded", () => {
        ScoreTrekBattle.View.register('/statistics', onViewRender, onViewLoad, onViewUpdate, onViewUnload);
    });

    return _this;
})();
